import { createContext, useContext } from "react";
import { en } from "./en";
import { es } from "./es";

export const dictionaries = { en, es };

export const LangContext = createContext({ lang: "en", t: en });

export const useLang = () => useContext(LangContext);

// Localized route map — single source of truth for both languages.
export const ROUTES = {
  home: { en: "/", es: "/es" },
  about: { en: "/about", es: "/es/nosotros" },
  services: { en: "/services", es: "/es/servicios" },
  resources: { en: "/resources", es: "/es/recursos" },
  blog: { en: "/blog", es: "/es/blog" },
  faq: { en: "/faq", es: "/es/faq" },
  contact: { en: "/contact", es: "/es/contacto" },
  privacy: { en: "/privacy-policy", es: "/es/privacy-policy" },
  terms: { en: "/terms", es: "/es/terms" },
  accessibility: { en: "/accessibility", es: "/es/accessibility" },
  editorial: { en: "/editorial-policy", es: "/es/editorial-policy" },
  disclosures: { en: "/disclosures", es: "/es/disclosures" },
  author: { en: "/author/escarling-martinez", es: "/es/author/escarling-martinez" },
};

export const route = (lang, key) => ROUTES[key][lang];

export const servicePath = (lang, slug) =>
  `${ROUTES.services[lang]}/${slug}`;

export const postPath = (lang, slug) => `${ROUTES.blog[lang]}/${slug}`;

const esToEn = {
  nosotros: "about",
  servicios: "services",
  recursos: "resources",
  contacto: "contact",
};
const enToEs = Object.fromEntries(
  Object.entries(esToEn).map(([esSeg, enSeg]) => [enSeg, esSeg]),
);

// Given the current pathname, return the equivalent path in the other language.
export function counterpartPath(pathname) {
  const isEs = pathname === "/es" || pathname.startsWith("/es/");
  if (isEs) {
    const rest = pathname.slice(3);
    if (!rest) return "/";
    const segs = rest.split("/").filter(Boolean);
    segs[0] = esToEn[segs[0]] || segs[0];
    return "/" + segs.join("/");
  }
  if (pathname === "/") return "/es";
  const segs = pathname.split("/").filter(Boolean);
  segs[0] = enToEs[segs[0]] || segs[0];
  return "/es/" + segs.join("/");
}
